import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/admin/login',
    method: 'post',
    timeout: 15000,
    skipAuth: true,
    authRequest: true,
    silentError: true,
    preserveErrorMessage: true,
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
    timeout: 15000,
    authRequest: true,
    silentError: true,
    preserveErrorMessage: true,
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function syncQiweiUsers() {
  return request({
    url: '/admin/syncQiweiUsers',
    method: 'post',
    timeout: 150000,
    silentError: true,
    preserveErrorMessage: true
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}


export function fetchListNew(params) {
  return request({
    url: '/admin/listNew',
    method: 'get',
    params: params
  })
}



export function getCurrentUserInfo() {
  return request({
    url: '/admin/getCurrentUserInfo',
    method: 'get'
  })
}




export function updatePassword(data) {
  return request({
    url: '/admin/updatePassword',
    method: 'post',
    data: data
  })
}




export function getNoticeTotal() {
  return request({
    url: '/admin/getNoticeTotal',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js